<template>
    <InlineEditInput
        :model-value="portfolioShortId"
        :save-handler="saveChanges"
        :validate-handler="validateSlug"
        dark-scheme
        char-limit-position="outside"
        :disabled="disabled"
        input-type="text"
        :max-length="24"
        leading-icon="link"
        :prefix-text="baseUrl"
    />
</template>

<script>
import PortfoliosAPI from "@/scripts/api/portfolios/PortfoliosAPI.js";
import InlineEditInput from "@/scripts/common/components/InlineEditInput.vue";

const validUrlSlugPattern = /^[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*$/;

export default {
    name: "InlineUrlEditInput",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        InlineEditInput,
    },
    computed: {
        portfolioShortId() {
            return this.$store.state.portfolio?.shortId || "";
        },
        baseUrl() {
            const origin = window?.location?.origin.replace(/^https?:\/\//, '') || "";
            return `${origin}/`;
        }
    },
    methods: {
        validateSlug(slug) {
            if (!slug || slug.length < 5 || !validUrlSlugPattern.test(slug)) {
                return "At least 5 letters, no special characters.";
            }
            return true;
        },
        async saveChanges(trimmed) {
            try {
                await PortfoliosAPI.updatePortfolioUrl(this.$store.state.portfolio._id, trimmed);
                this.$store.commit("updatePortfolioShortId", trimmed);
                this.$store.commit("showAlertMessage", {
                    type:'success',
                    message: "Default domain successfully updated."
                });
            } catch (error) {
                const apiMessage = error?.response?.data?.message;
                throw new Error(apiMessage || "Something went wrong. Please try again.");
            }
        }
    }
}
</script>
